import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGroupsServices } from '../../services/commonapi/commonApi';


export const fetchGroups = createAsyncThunk(
  'groups/fetchGroups',
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await getGroupsServices(accessToken);
      if (response.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch user data');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'An error occurred');
    }
  }
);

const groupsSlice = createSlice({
  name: 'groups',
  initialState: {
    groupsData: [],
    groupLoading: false,
    error: null,
  },
  reducers: {
    resetGroupsState: (state) => {
      state.groupsData = [];
      state.groupLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (state) => {
        state.groupLoading = true;
        state.error = null;
      })
      .addCase(fetchGroups.fulfilled, (state, action) => {
        state.groupsData = action.payload;
        state.groupLoading = false;
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        state.groupLoading = false;
        state.error = action.payload;
      });
  },
});
export const { resetGroupsState } = groupsSlice.actions;
export default groupsSlice.reducer;
